import { ResourceEnum } from "src/constants/constants.ts";
import type { TFunction } from "i18next";
import React from "react";
import type { Module } from "src/system/module.types.ts";
import type { AccountingPostingResource } from "@exonn/js-sdk/src/namespaces/accounting-posting";
import { renderCustomForm } from "src/admin/modules/accounting-posting/renderCustomForm.tsx";

export const module: Module<AccountingPostingResource> = {
  id: ResourceEnum.AccountingPosting,
  bigIcon: <span className={"icon-20-reservation"} />,
  smallIcon: <span className={"icon-15-reservation"} />,
  name: (t: TFunction) => t("moduleName.accounting-posting"),
  list: {
    hideDeleteAction: (row) => {
      return row.is_blocked;
    },
  },
  renderForm: renderCustomForm,
  tabs: {
    edit: {
      getTitle: (resource: AccountingPostingResource) => resource.number,
    },
  },
};
